import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// Keep the existing page reset available when route screens load on demand.
import './splashComponent/desktop_splash.css';
import reportWebVitals from './reportWebVitals';
import { installDomMutationGuard } from './shared-components/domErrorRecovery';

// Must run before the first render so React never crashes on nodes changed by translate/extensions.
installDomMutationGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
